import { render, staticRenderFns } from "./AutoAssignConfig.vue?vue&type=template&id=14b9abc8&scoped=true&"
import script from "./AutoAssignConfig.vue?vue&type=script&lang=js&"
export * from "./AutoAssignConfig.vue?vue&type=script&lang=js&"
import style0 from "./AutoAssignConfig.vue?vue&type=style&index=0&id=14b9abc8&scoped=true&lang=scss&"
import style1 from "../../components/style/staff.scss?vue&type=style&index=1&id=14b9abc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9abc8",
  null
  
)

export default component.exports